import { SheLocation } from '../types/location';
import { MainV3ApiBase } from './base';

export const LocationApis = {
  findAllBases() {
    return MainV3ApiBase.appendPath('locations').get<SheLocation[]>({ location_type: 'official_base' });
  },
  findAll() {
    return MainV3ApiBase.appendPath('locations').get<SheLocation[]>();
  },
};
